module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/pond/Room_pond_01.png";